import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './components/Layout'
import { Dashboard } from './pages/Dashboard'
import { Agents } from './pages/Agents'
import { AgentBuilder } from './pages/AgentBuilder'
import { DeployAgent } from './pages/DeployAgent'
import { Teams } from './pages/Teams'
import { ResourcesPage } from './pages/Resources'
import { HolacracyCanvas } from './pages/HolacracyCanvas'
import { Settings } from './pages/Settings'
import { CircleInstancesPage, InstanceAgentsPage, InstanceTeamsPage } from './pages/InstanceSection'
import { Login } from './pages/Login'
import { AuthCallback } from './pages/AuthCallback'
import { MentionsLegales } from './pages/MentionsLegales'
import { Contact } from './pages/Contact'
import { Privacy } from './pages/Privacy'
import { Terms } from './pages/Terms'
import { TeamInspector } from './pages/TeamInspector'
import { SpendingTracker } from './pages/SpendingTracker'
import { FollowUp } from './pages/FollowUp'
import { useAuthStore } from './stores/authStore'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore()
  return isAuthenticated ? (
    <>
      <div className="studio-brand">
        <img src="/logo.jpg" alt="AgentTeamForge Logo" />
        <h1 className="text-2xl font-bold tracking-tight text-robot-blue" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          AgentTeamForge Studio
        </h1>
      </div>
      {children}
    </>
  ) : <Navigate to="/login" replace />
}

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/login" element={<Login />} />
      <Route path="/legal/mentions" element={<MentionsLegales />} />
      <Route path="/legal/privacy" element={<Privacy />} />
      <Route path="/legal/terms" element={<Terms />} />
      <Route path="/contact" element={<Contact />} />
      
      {/* Protected routes */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/agents" element={<Agents />} />
                <Route path="/agents/new" element={<AgentBuilder />} />
                <Route path="/agents/:id/edit" element={<AgentBuilder />} />
                <Route path="/agents/deploy" element={<DeployAgent />} />
                <Route path="/teams" element={<Teams />} />
                <Route path="/teams/resources" element={<ResourcesPage />} />
                <Route path="/teams/circles" element={<HolacracyCanvas />} />
                <Route path="/instances/agents" element={<InstanceAgentsPage />} />
                <Route path="/instances/equipes" element={<InstanceTeamsPage />} />
                <Route path="/instances/cercles" element={<CircleInstancesPage />} />
                <Route path="/monitoring" element={<Navigate to="/instances/agents" replace />} />
                <Route path="/settings" element={<Navigate to="/settings/profil" replace />} />
                <Route path="/settings/profil" element={<Settings panel="profil" />} />
                <Route path="/settings/secrets" element={<Settings panel="secrets" />} />
                <Route path="/settings/admin" element={<Settings panel="admin" />} />
                <Route path="/team-inspector" element={<TeamInspector />} />
                <Route path="/spending" element={<SpendingTracker />} />
                <Route path="/suivi" element={<Navigate to="/suivi/statistiques" replace />} />
                <Route path="/suivi/statistiques" element={<FollowUp presentation="table" />} />
                <Route path="/suivi/graphiques" element={<FollowUp presentation="chart" />} />
                <Route path="/agent-usage" element={<Navigate to="/suivi/statistiques" replace />} />
                <Route path="/secrets" element={<Navigate to="/settings/secrets" replace />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}

export default App
